import { useCallback, useContext } from 'react';
import TooltipContext from "../context/TooltipContext.js";
import useEventEmitters from "./useEventEmitters.js";
import useEventHandlers from "./useEventHandlers.js";
/** This hook simplifies the logic for initializing Series event emitters + handlers. */
export default function useSeriesEvents(_ref) {
  let {
    dataKey,
    enableEvents,
    findNearestDatum,
    onBlur: onBlurProps,
    onFocus: onFocusProps,
    onPointerMove: onPointerMoveProps,
    onPointerOut: onPointerOutProps,
    onPointerUp: onPointerUpProps,
    onPointerDown: onPointerDownProps,
    source,
    allowedSources
  } = _ref;
  const {
    showTooltip,
    hideTooltip
  } = useContext(TooltipContext) ?? {};
  const onPointerMove = useCallback(params => {
    showTooltip(params);
    if (onPointerMoveProps) onPointerMoveProps(params);
  }, [showTooltip, onPointerMoveProps]);
  const onFocus = useCallback(params => {
    showTooltip(params);
    if (onFocusProps) onFocusProps(params);
  }, [showTooltip, onFocusProps]);
  const onPointerOut = useCallback(event => {
    hideTooltip();
    if (event && onPointerOutProps) onPointerOutProps(event);
  }, [hideTooltip, onPointerOutProps]);
  const onBlur = useCallback(event => {
    hideTooltip();
    if (event && onBlurProps) onBlurProps(event);
  }, [hideTooltip, onBlurProps]);
  const onPointerDown = useCallback(params => {
    showTooltip(params);
    if (onPointerDownProps) onPointerDownProps(params);
  }, [showTooltip, onPointerDownProps]);
  useEventHandlers({
    dataKey,
    findNearestDatum,
    onBlur: enableEvents ? onBlur : undefined,
    onFocus: enableEvents ? onFocus : undefined,
    onPointerMove: enableEvents ? onPointerMove : undefined,
    onPointerOut: enableEvents ? onPointerOut : undefined,
    onPointerUp: enableEvents ? onPointerUpProps : undefined,
    onPointerDown: enableEvents ? onPointerDown : undefined,
    allowedSources
  });
  return useEventEmitters({
    source,
    onBlur: !!onBlurProps && enableEvents,
    onFocus: !!onFocusProps && enableEvents,
    onPointerMove: !!onPointerMoveProps && enableEvents,
    onPointerOut: !!onPointerOutProps && enableEvents,
    onPointerUp: !!onPointerUpProps && enableEvents,
    onPointerDown: !!onPointerDownProps && enableEvents
  });
}